import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .grace-layout.mobile-rows-1 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .block-header {
        grid-row: 2;
      }
      .images-wrapper {
        grid-row: 2;
      }
    }

    .grace-layout.mobile-rows-2 {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];

      .block-header {
        grid-row: 2;
      }
      .images-wrapper {
        grid-row: 3;
      }
    }

    .block-header {
      grid-column: 2 / 8;
      /* Sized by the h3 defaults (16/20 mobile, 24/30 desktop). */
      padding: calc(4rem / var(--default-rem-px-count)) 0;
    }

    /* Card row: single column on mobile, nested 12-col grid at 600px. */
    .images-wrapper {
      grid-column: 2 / 8;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: var(--between-row-padding-lg) var(--between-column-padding-lg);
    }

    /* Card title and CTA share a first baseline. */
    .details {
      display: grid;
      grid-template-columns: repeat(12, minmax(0, 1fr));
      align-items: baseline;
      gap: 0 var(--between-column-padding);
      padding-top: calc(16rem / var(--default-rem-px-count));
    }

    .details h2 {
      grid-column: 1 / 7;
    }

    .image-cta {
      grid-column: 7 / 13;
      display: flex;
      justify-content: end;
      font-weight: 400;
    }

    /* cta-text sets align-self on its own :host; only a rule from out here
       lets it join the baseline group. */
    .image-cta > cta-text {
      align-self: baseline;
    }

    .description {
      grid-column: 7 / 13;
      display: none;
    }

    img {
      width: 100%;
      min-height: calc(150rem / var(--default-rem-px-count));
      object-fit: cover;
    }

    .images-wrapper.square-images img {
      min-height: unset;
    }

    @media (min-width: 600px) {
      .block-header {
        margin-bottom: var(--between-row-padding-lg);
      }

      .images-wrapper {
        grid-column: 2 / 14;
        grid-template-columns: repeat(12, minmax(0, 1fr));
      }

      a.image-wrapper {
        cursor: pointer;
      }

      .image-wrapper {
        grid-column: span 6;
      }

      img {
        min-height: unset;
        max-height: calc(400rem / var(--default-rem-px-count));
      }

      .images-wrapper.square-images img {
        max-height: unset;
      }

      .description {
        display: inherit;
      }

      .details {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }
    }
  `,
];
